import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const BannerAdd = () => {
  const navigate = useNavigate();

  const [Bannerimage, setBannerImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setBannerImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("banner_img", Bannerimage);

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_banner_image",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === "1") {
        toast.success(response.data.message || "Banner added successfully!");
        setBannerImage(null);
        setPreviewImage(null);
        navigate("/Master/Banner");
      } else {
        toast.error(response.data.error || "Failed to add Banner");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="container mt-5">
      {/* Form Card */}
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0 text-white text-center">Add Banner Data</h4>
        </div>

        <div className="card-body">
          <form className="row g-4" onSubmit={submitForm}>
            {/* Image */}
            <div className="col-md-6">
              <label htmlFor="banner_img" className="form-label">
                Image
              </label>
              <input
                type="file"
                className="form-control"
                id="banner_img"
                accept="image/*"
                onChange={handleImageChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="mt-2"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
            </div>

            {/* Submit Button */}
            <div className="col-12 d-flex justify-content-end">
              <button
                type="submit"
                className="add-btn text-white text-center"
              >
                Add Banner
              </button>
              <div className="mb-3 ">
                <Link
                  to="/Master/Banner"
                  className="btn btn-secondary text-white"
                >
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
